import { render, staticRenderFns } from "./top-travelers.vue?vue&type=template&id=fb78beae&scoped=true&"
import script from "./top-travelers.vue?vue&type=script&lang=js&"
export * from "./top-travelers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb78beae",
  null
  
)

export default component.exports